'use client';

import { CarListingData, CarStatus } from '@/types';
import { comparableTypes } from '@/utils/filterUtil';

export const AvailableCheckClient = (
    item: CarListingData,
    availablity: comparableTypes
) => {
    let availableCheck = true;

    if (
        (availablity as CarStatus) === CarStatus.AVAILABLE &&
        (item.isReserved || item.isPurchaseInProgress)
    )
        availableCheck = false;

    if (
        (availablity as CarStatus) === CarStatus.RESERVED &&
        (item.isPurchaseInProgress || !item.isReserved)
    )
        availableCheck = false;

    if (
        (availablity as CarStatus) === CarStatus.BEING_SOLD &&
        !item.isPurchaseInProgress
    )
        availableCheck = false;
    return availableCheck;
};
